import * as yup from 'yup';

export const validationSchema2Step = yup.object().shape({
  company: yup.object().shape({
    name: yup.string().required(),
    address: yup.string().required(),
    phone: yup.string().required(),
    website: yup.string().required(),
  }),
});

export const validationSchema2StepNonArup = yup.object().shape({
  company: yup.object().shape({
    name: yup.string().required('Company name is required'),
    companyCountry: yup.string().required('Street address is required'),
    companyCity: yup.string().required('City is required'),
    country: yup.string().required('Country is required'),
    phone: yup.string().required('Phone number is required'),
    website: yup.string().required('Website is required'),
  }),
});
